'use client';
import { useState } from 'react';
import {
  Spin,
  Form,
  Checkbox,
  Input,
  Select,
  Radio,
  Button,
  message,
  Table,
} from 'antd';
import Dict from './dict';

const { Item: FormItem } = Form;

type Props = {
  slug: string;
};

export default function AutoCalcComponent({ slug }: Props) {
  const { formulaImage, formData, defaultResultList } =
    Dict[slug as keyof typeof Dict] || Dict['coupling'];
  const [spinning, setSpinning] = useState(false);
  const [resultList, setResultList] = useState(defaultResultList);
  const [paramsForm] = Form.useForm();
  const paramsColumn = [
    {
      title: '参数名称',
      dataIndex: 'label',
      key: 'label',
      width: 230,
      align: 'center',
      className: '!bg-[#f0f0f0] text-[#333] font-bold',
      render: (text: string, record: any) => {
        return (
          <div>
            {record.required && <span className="text-main">*</span>}
            <span className="text-[#333]">{text}</span>
          </div>
        );
      },
    },
    {
      title: '参数值名称',
      dataIndex: 'name',
      key: 'name',
      width: 230,
      className: '!bg-white',
      onCell: (record: any, index: number) => {
        return { colSpan: record?.colSpan ? 2 : 1 };
      },
      render: (text: string, record: any, index: number) => {
        let component: any = '';

        switch (record.type) {
          case 'Input':
            component = <Input placeholder="请输入值" />;
            break;
          case 'Select':
            component = (
              <Select options={record.options} placeholder="请选择值" />
            );
            break;
          case 'Radio':
            component = <Radio.Group options={record.options} />;
            break;
          default:
            component = <Input placeholder="请输入值" />;
            break;
        }

        return (
          <FormItem
            rules={[{ required: record.required }]}
            initialValue={record.initialValue}
            help={''}
            name={text}
          >
            {component}
          </FormItem>
        );
      },
    },
    {
      title: '参数描述',
      dataIndex: 'desc',
      key: 'desc',
      className: '!bg-[#f0f0f0] !text-[#666] text-base',
      onCell: (record: any, index: number) => {
        return { colSpan: record?.colSpan ? 0 : 1 };
      },
    },
  ];

  const resultColumn = [
    {
      title: '参数名称',
      dataIndex: 'label',
      key: 'label',
      width: 230,
      align: 'center',
      className: '!bg-[#f0f0f0] text-[#333] font-bold',
    },
    {
      title: '参数值',
      dataIndex: 'value',
      key: 'value',
      width: 230,
      className: '!text-main text-base',
    },
    {
      title: '参数描述',
      dataIndex: 'desc',
      key: 'desc',
      className: 'bg-[#f0f0f0] text-[#666] text-base',
    },
  ];

  // 获取计算结果
  const getCalculationResults = () => {
    paramsForm
      .validateFields()
      .then((res) => {
        let formValues = paramsForm.getFieldsValue();

        setSpinning(true);
        // 模拟数据请求
        setTimeout(() => {
          let newResult = resultList.map((item: any, index: number) => {
            return { ...item, value: index + 33 };
          });

          setResultList(newResult);
          setSpinning(false);
          message.open({
            type: 'success',
            content: '已生成结果',
          });
        }, 800);
      })
      .catch((err) => {
        console.log(err);
        message.open({
          type: 'error',
          content: '参数填写不完整',
        });
      });
  };

  // 重置表单
  const resetForm = () => {
    paramsForm.resetFields();
    setResultList(defaultResultList);
  };

  return (
    <div className="auto-calc-component">
      <div className="px-[40px] pt-[16px] pb-[50px] bg-white min-h-[600px] flex gap-x-[80px]">
        {/* 产品查看器 */}
        <div className="flex-1">
          <img src={formulaImage} className="w-[100%]" />
        </div>
        <div className="w-[820px]">
          {/* 参数输入 */}
          <div>
            <div
              className={`px-[20px] flex flex-row justify-between items-center bg-[url('/calculation-selection/form_top_bg.png')] bg-cover h-[70px]`}
            >
              <div className="text-white text-xl ml-[16px] font-bold">
                参数输入
              </div>
              <div>
                <button
                  className="w-[104px] h-[30px] text-base text-white border-[#fff] border"
                  onClick={() => resetForm()}
                >
                  重置参数值
                </button>
              </div>
            </div>
            <Form form={paramsForm}>
              {/* @ts-ignore */}
              <Table
                className="params-table"
                showHeader={false}
                dataSource={formData}
                // @ts-ignore
                columns={paramsColumn}
                pagination={{ hideOnSinglePage: true }}
                bordered
              ></Table>
            </Form>
            <div className="mt-[20px] flex items-center justify-end">
              <button
                className="w-[200px] h-[48px] text-[18px] text-white bg-main border-[#fff] border"
                onClick={() => getCalculationResults()}
              >
                立即计算
              </button>
            </div>
          </div>
          {/* 计算结果 */}
          <div className="mt-[40px]">
            <div className="px-[36px] h-[70px] flex items-center bg-main text-white text-xl">
              计算结果（点击 “立即计算” 后得出结果）
            </div>
            {/* @ts-ignore */}
            <Table
              showHeader={false}
              dataSource={resultList}
              // @ts-ignore
              columns={resultColumn}
              pagination={{ defaultPageSize: 100, hideOnSinglePage: true }}
              bordered
            ></Table>
          </div>
        </div>
      </div>
      {/* 全屏loading */}
      <Spin spinning={spinning} fullscreen />
      <style>
        {/* antd 默认样式修改 */}
        {`
                    .auto-calc-component .ant-form-item {
                        margin-bottom:0px !important;
                    }

                    .auto-calc-component .ant-table-wrapper table
                    .auto-calc-component .ant-table-wrapper .ant-table,
                    .auto-calc-component .ant-table-wrapper .ant-table-container,
                    .auto-calc-component .ant-table-wrapper .ant-table-container table thead tr:first-child *:first-child,
                    .auto-calc-component .ant-table-wrapper .ant-table-container table thead tr:first-child *:last-child {
                        border-radius: 0 !important;
                    }
                    .auto-calc-component .ant-table-wrapper .ant-table.ant-table-bordered .ant-table-container{
                        border-inline-start: 1px solid #ccc;
                        border-top: 1px solid #ccc;
                    }
                    .auto-calc-component .ant-table-wrapper .ant-table-thead tr th, 
                    .auto-calc-component .ant-table-wrapper .ant-table-thead tr td {
                        border-inline-end:1px solid #ccc !important;
                        border-bottom: 1px solid #ccc;
                        background: #f0f0f0;
                    }
                    .auto-calc-component .ant-table-wrapper .ant-table-tbody tr th, 
                    .auto-calc-component .ant-table-wrapper .ant-table-tbody tr td {
                        border-inline-end:1px solid #ccc !important;
                        border-bottom: 1px solid #ccc;
                    }
                `}
      </style>
    </div>
  );
}
